import { render } from "./StartSeite.vue?vue&type=template&id=af238446&scoped=true"
import script from "./StartSeite.vue?vue&type=script&lang=js"
export * from "./StartSeite.vue?vue&type=script&lang=js"

import "./StartSeite.vue?vue&type=style&index=0&id=af238446&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af238446"]])

export default __exports__